{
  "title": "version",
  "type": "object",
  "uniqueItems": true,
  "properties": {
    "version": {
      "description": "The protocol version",
      "type": "integer"
    },
    "minecraftVersion": {
      "type": "string",
      "pattern": "([0-9]+\\.[0-9]+(\\.[0-9]+)?[a-z]?(-pre[0-9]+)?)|([0-9]{2}w[0-9]{2}[a-z])"
    },
    "majorVersion": {
      "type": "string",
      "pattern": "[0-9]+\\.[0-9]+[a-z]?"
    },
    "releaseType": {
      "type": "string",
      "pattern": "[a-z]+"
    }
  },
  "additionalProperties": false
}
